module.exports = __webpack_public_path__ + "img/grid.5b25ebac.png";